import { Card, CardBody, Col } from "reactstrap";
import { RoundedPaginationTitle } from "../../../Constants/Constants";
import { RoundedListData, RoundedPageSubTitle } from "../../../Data/BonusUi/Pagination";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DefaultPaginationList from "./Common/DefaultPaginationList";

const RoundedPagination = () => {
  return (
    <Col md="6">
      <Card className="height-equal">
        <CommonCardHeader title={RoundedPaginationTitle} span={RoundedPageSubTitle} />
        <CardBody>
          <DefaultPaginationList pageColor="dark" data={RoundedListData} classLink="rounded-circle" listClass="gap-2" />
        </CardBody>
      </Card>
    </Col>
  );
};
export default RoundedPagination;
